import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import translationEN from './locales/en/translation.json'
import translationPL from './locales/pl/translation.json'

const savedLanguage = localStorage.getItem('lng') || 'pl'

const resources = {
  en: { translation: translationEN },
  pl: { translation: translationPL },
}

i18n.use(initReactI18next).init({
  resources,
  lng: savedLanguage,
  fallbackLng: 'pl',
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
